export enum ArticleVariants {
  DEPRECATED = 'deprecated',
  DEFAULT = 'default',
}

export enum ArticleBodyVariants {
  DEFAULT = 'default',
  HIGHLIGHT = 'highlight',
}
